import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { Menu, Separator, Item, MenuProvider } from "react-contexify";
import "react-contexify/dist/ReactContexify.min.css";
import "./FinishButton.css";
import "../../node_modules/font-awesome/css/font-awesome.min.css";

class FinishButton extends Component {
  finishRetroAndRedirect = sendEmails => {
    this.props.finishRetro(sendEmails);
    this.props.history.push("/finished");
  };

  timer = null;
  onMouseDown = event => {
    //Detect right click or CTRL key (which right clicks) is held down and disregard
    if (event.nativeEvent.which === 3 || event.ctrlKey) {
      return false;
    }

    this.props.scrollToBottom("instant");
    this.timer = setTimeout(() => {
      const sendEmails = true;
      this.finishRetroAndRedirect(sendEmails);
    }, 1000);
  };

  killTimer = () => {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  };

  componentWillMount() {
    window.addEventListener("mouseup", this.killTimer);
  }

  handleDeleteRetro = () => {
    this.props.deleteRetro();
    this.props.history.push("/");
  };

  handleFinishRetroSkipEmails = () => {
    const sendEmails = false;
    this.finishRetroAndRedirect(sendEmails);
  };

  render() {
    const styles = {
      fontSize: ".75em",
    };

    const ContextMenu = () => (
      <Menu id="menu_id" className="context-menu">
        <Item onClick={this.handleDeleteRetro} style={styles}>
          Forget this retro session
        </Item>
        <Separator />
        <Item onClick={this.handleFinishRetroSkipEmails} style={styles}>
          Finish w/o email summary
        </Item>
      </Menu>
    );

    return (
      <div className="finish-button-container">
        <MenuProvider id="menu_id">
          <div
            className="finish-button action-button"
            onMouseDown={event => this.onMouseDown(event)}
          >
            <div className="finish-circle action-circle">
              <span className="fa fa-stop icon" />
            </div>
            <div className="text-container action-text-container">
              <div className="default-text">Finish Retro</div>
              <div className="hover-text">Hold to Finish</div>
            </div>
          </div>
        </MenuProvider>
        <ContextMenu />
      </div>
    );
  }
}

FinishButton.propTypes = {
  scrollToBottom: PropTypes.func.isRequired,
  finishRetro: PropTypes.func.isRequired,
  deleteRetro: PropTypes.func.isRequired,
};

export default withRouter(FinishButton);



// WEBPACK FOOTER //
// ./src/components/FinishButton.js